import { Spin } from 'antd'
import { View } from 'components/shared/LegacyView'

export const Loading = () => {
  return (
    <View
      customStyle={{
        height: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin />
    </View>
  )
}
